import { render, staticRenderFns } from "./SearchAccountCard.vue?vue&type=template&id=6570f0ae"
import script from "./SearchAccountCard.vue?vue&type=script&lang=ts"
export * from "./SearchAccountCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports